import React, { Fragment, useState } from 'react';
import './AmountInformation.css';
import CustomModal from '../../../../Components/CustomModal/CustomModal';
import { NewContactIcon } from '../../../../Assets/Navigation/NavigationIcons';
import ContactDetails from '../../../../Pages/Contact/ContactDetails/index';
import { useTranslation } from 'react-i18next';
const AmountInformation = ({
  price,
  account,
  description,
  currency,
  Tax = null,
  preferredVendor = null,
  inModal = false,
}) => {
  const { t } = useTranslation();
  const [showContactModal, setShowContactModal] = useState(false);

  const viewContactModal = () => {
    return (
      <CustomModal
        size="large"
        className="contacts_modal_view"
        showModal={showContactModal}
        title={t('Items.view_contact')}
        modaltitle="inventory_modal_title"
        // minWidth={120}
        Icon={NewContactIcon}
        renderActions={false}
        onClose={() => setShowContactModal(false)}
        linkTo={
          preferredVendor &&
          preferredVendor.id &&
          `contacts/${preferredVendor.id}`
        }
      >
        <ContactDetails id={preferredVendor?.id || ''} inModal />
      </CustomModal>
    );
  };
  const handleModel = () => {
    setShowContactModal(true);
  };
  return (
    <Fragment>
      {showContactModal && viewContactModal()}

      <div className="section-details--info-details">
        <div className="item-purchase-sales-info">
          <div className="section-details--info-title bold">
            {t('Items.price')}
          </div>
          <div className="margin-bottom-sm">{price}</div>
        </div>

        <div className="item-purchase-sales-info">
          <div className="section-details--info-title bold">
            {t('Items.account')}
          </div>
          <div className="margin-bottom-sm">{account}</div>
        </div>

        {Tax && (
          <div className="item-purchase-sales-info">
            <div className="section-details--info-title bold">
              {t('Items.tax')}
            </div>
            <div className="margin-bottom-sm">
              <span>
                {Tax.name} (
                {Tax.type === "fixed" && currency?.symbol}
                {Tax.rate}
                {Tax.type === "percentage" && "%"}
                )
                {Tax.authority && ` - ${Tax.authority}`}
              </span>            </div>
          </div>
        )}

        {preferredVendor && preferredVendor.id && (
          <div className="item-purchase-sales-info">
            <div className="section-details--info-title bold">
              {t('Items.preferred_vendor')}
            </div>
            <div className="margin-bottom-sm">
              {inModal ? (
                <a
                  href={`/contacts/${preferredVendor.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {preferredVendor.display_name}
                </a>
              ) : (
                <div onClick={handleModel}>{preferredVendor.display_name}</div>
              )}
            </div>
          </div>
        )}
        <div className="item-purchase-sales-info mt-2">
          <div className="section-details--info-title bold">
            {t('Items.description')}
          </div>
          <div className="margin-bottom-sm w-100">
            {description ? description : 'N/A'}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AmountInformation;
